<template>
  <el-table
    ref="oriTable"
    border
    :data="writeSampleList"
    height="100%"
    size="mini"
    row-key="itemNo"
    :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
    @selection-change="handleSelectionChange"
  >
    <el-table-column type="selection" width="40" align="center"></el-table-column>
    <el-table-column align="center" min-width="220" :show-overflow-tooltip="false" fixed>
      <template v-slot:header>
        <div class="flx-center">
          <span>试件编号</span>
          <el-button
            type="text"
            size="medium"
            icon="el-icon-edit-outline"
            @click="handleBatchEdit('试件编号', 'itemNo')"
          ></el-button>
        </div>
      </template>
      <template v-slot="{ row, $index }">
        <el-input
          v-if="focusCell === `ori${$index}itemNo`"
          :id="`ori${$index}itemNo`"
          v-model="row.itemNo"
          placeholder="请输入"
        ></el-input>
        <div v-else class="m-input" @click="updateFocusCell(`ori${$index}itemNo`)">{{ row.itemNo }}</div>
      </template>
    </el-table-column>
    <el-table-column align="center" min-width="160" :show-overflow-tooltip="false">
      <template v-slot:header>
        <div class="flx-center">
          <span>试件名称</span>
          <el-button
            type="text"
            size="medium"
            icon="el-icon-edit-outline"
            @click="handleBatchEdit('试件名称', 'sampleBelong')"
          ></el-button>
        </div>
      </template>
      <template v-slot="{ row, $index }">
        <el-input
          v-if="focusCell === `ori${$index}sampleBelong`"
          :id="`ori${$index}sampleBelong`"
          v-model="row.sampleBelong"
          placeholder="请输入"
        ></el-input>
        <div v-else class="m-input" @click="updateFocusCell(`ori${$index}sampleBelong`)">{{ row.sampleBelong }}</div>
      </template>
    </el-table-column>
    <el-table-column align="center" min-width="160" :show-overflow-tooltip="false">
      <template v-slot:header>
        <div class="flx-center">
          <span>检测对象</span>
          <el-button
            type="text"
            size="medium"
            icon="el-icon-edit-outline"
            @click="handleBatchEdit('检测对象', 'sampleName')"
          ></el-button>
        </div>
      </template>
      <template v-slot="{ row, $index }">
        <el-input
          v-if="focusCell === `ori${$index}sampleName`"
          :id="`ori${$index}sampleName`"
          v-model="row.sampleName"
          placeholder="请输入"
        ></el-input>
        <div v-else class="m-input" @click="updateFocusCell(`ori${$index}sampleName`)">{{ row.sampleName }}</div>
      </template>
    </el-table-column>
    <el-table-column lalign="center" min-width="140" :show-overflow-tooltip="false">
      <template v-slot:header>
        <div class="flx-center">
          <span>试件型号</span>
          <el-button
            type="text"
            size="medium"
            icon="el-icon-edit-outline"
            @click="handleBatchEdit('试件型号', 'model')"
          ></el-button>
        </div>
      </template>
      <template v-slot="{ row, $index }">
        <el-input
          v-if="focusCell === `ori${$index}model`"
          :id="`ori${$index}model`"
          v-model="row.model"
          placeholder="请输入"
        ></el-input>
        <div v-else class="m-input" @click="updateFocusCell(`ori${$index}model`)">{{ row.model }}</div>
      </template>
    </el-table-column>
    <el-table-column align="center" min-width="220" :show-overflow-tooltip="false">
      <template v-slot:header>
        <div class="flx-center">
          <span>生产厂家</span>
          <el-button
            type="text"
            size="medium"
            icon="el-icon-edit-outline"
            @click="handleBatchEdit('生产厂家', 'manufacturer')"
          ></el-button>
        </div>
      </template>
      <template v-slot="{ row, $index }">
        <el-input
          v-if="focusCell === `ori${$index}manufacturer`"
          :id="`ori${$index}manufacturer`"
          v-model="row.manufacturer"
          placeholder="请输入"
        ></el-input>
        <div v-else class="m-input" @click="updateFocusCell(`ori${$index}manufacturer`)">{{ row.manufacturer }}</div>
      </template>
    </el-table-column>
    <el-table-column align="center" min-width="140" :show-overflow-tooltip="false">
      <template v-slot:header>
        <div class="flx-center">
          <span>试验日期</span>
          <el-button
            type="text"
            size="medium"
            icon="el-icon-edit-outline"
            @click="handleBatchEdit('试验日期', 'testedTime')"
          ></el-button>
        </div>
      </template>
      <template v-slot="{ row, $index }">
        <el-input
          v-if="focusCell === `ori${$index}testedTime`"
          :id="`ori${$index}testedTime`"
          v-model="row.testedTime"
          placeholder="请输入"
        ></el-input>
        <div v-else class="m-input" @click="updateFocusCell(`ori${$index}testedTime`)">{{ row.testedTime }}</div>
      </template>
    </el-table-column>
    <el-table-column align="center" min-width="100" :show-overflow-tooltip="false">
      <template v-slot:header>
        <div class="flx-center">
          <span>温度</span>
          <el-button type="text" size="medium" icon="el-icon-edit-outline" @click="handleBatchEdit('温度', 'wd')"></el-button>
        </div>
      </template>
      <template v-slot="{ row, $index }">
        <el-input v-if="focusCell === `ori${$index}wd`" :id="`ori${$index}wd`" v-model="row.wd" placeholder="请输入"></el-input>
        <div v-else class="m-input" @click="updateFocusCell(`ori${$index}wd`)">{{ row.wd }}</div>
      </template>
    </el-table-column>
    <el-table-column align="center" min-width="100" :show-overflow-tooltip="false">
      <template v-slot:header>
        <div class="flx-center">
          <span>湿度</span>
          <el-button type="text" size="medium" icon="el-icon-edit-outline" @click="handleBatchEdit('湿度', 'td')"></el-button>
        </div>
      </template>
      <template v-slot="{ row, $index }">
        <el-input v-if="focusCell === `ori${$index}td`" :id="`ori${$index}td`" v-model="row.td" placeholder="请输入"></el-input>
        <div v-else class="m-input" @click="updateFocusCell(`ori${$index}td`)">{{ row.td }}</div>
      </template>
    </el-table-column>
    <el-table-column align="center" min-width="100" :show-overflow-tooltip="false">
      <template v-slot:header>
        <div class="flx-center">
          <span>试件厚度</span>
          <el-button
            type="text"
            size="medium"
            icon="el-icon-edit-outline"
            @click="handleBatchEdit('试件厚度', 'shd')"
          ></el-button>
        </div>
      </template>
      <template v-slot="{ row, $index }">
        <el-input
          v-if="focusCell === `ori${$index}shd`"
          :id="`ori${$index}shd`"
          v-model="row.shd"
          placeholder="请输入"
        ></el-input>
        <div v-else class="m-input" @click="updateFocusCell(`ori${$index}shd`)">{{ row.shd }}</div>
      </template>
    </el-table-column>
    <el-table-column align="center" min-width="100" :show-overflow-tooltip="false">
      <template v-slot:header>
        <div class="flx-center">
          <span>测点1</span>
          <el-button
            type="text"
            size="medium"
            icon="el-icon-edit-outline"
            @click="handleBatchEdit('测点1', 'oriDataList', 0, 'p1')"
          ></el-button>
        </div>
      </template>
      <template v-slot="{ row, $index }">
        <el-input
          v-if="focusCell === `ori${$index}0p1`"
          :id="`ori${$index}0p1`"
          v-model="row.oriDataList[0].p1"
          placeholder="请输入"
          clearable
        ></el-input>
        <div v-else class="m-input" @click="updateFocusCell(`ori${$index}0p1`)">{{ row.oriDataList[0].p1 }}</div>
      </template>
    </el-table-column>
    <el-table-column align="center" min-width="100" :show-overflow-tooltip="false">
      <template v-slot:header>
        <div class="flx-center">
          <span>测点2</span>
          <el-button
            type="text"
            size="medium"
            icon="el-icon-edit-outline"
            @click="handleBatchEdit('测点2', 'oriDataList', 0, 'p2')"
          ></el-button>
        </div>
      </template>
      <template v-slot="{ row, $index }">
        <el-input
          v-if="focusCell === `ori${$index}0p2`"
          :id="`ori${$index}0p2`"
          v-model="row.oriDataList[0].p2"
          placeholder="请输入"
          clearable
        ></el-input>
        <div v-else class="m-input" @click="updateFocusCell(`ori${$index}0p2`)">{{ row.oriDataList[0].p2 }}</div>
      </template>
    </el-table-column>
    <el-table-column align="center" min-width="100" :show-overflow-tooltip="false">
      <template v-slot:header>
        <div class="flx-center">
          <span>测点3</span>
          <el-button
            type="text"
            size="medium"
            icon="el-icon-edit-outline"
            @click="handleBatchEdit('测点3', 'oriDataList', 0, 'p3')"
          ></el-button>
        </div>
      </template>
      <template v-slot="{ row, $index }">
        <el-input
          v-if="focusCell === `ori${$index}0p3`"
          :id="`ori${$index}0p3`"
          v-model="row.oriDataList[0].p3"
          placeholder="请输入"
          clearable
        ></el-input>
        <div v-else class="m-input" @click="updateFocusCell(`ori${$index}0p3`)">{{ row.oriDataList[0].p3 }}</div>
      </template>
    </el-table-column>
    <el-table-column align="center" min-width="100" :show-overflow-tooltip="false">
      <template v-slot:header>
        <div class="flx-center">
          <span>测点4</span>
          <el-button
            type="text"
            size="medium"
            icon="el-icon-edit-outline"
            @click="handleBatchEdit('测点4', 'oriDataList', 0, 'p4')"
          ></el-button>
        </div>
      </template>
      <template v-slot="{ row, $index }">
        <el-input
          v-if="focusCell === `ori${$index}0p4`"
          :id="`ori${$index}0p4`"
          v-model="row.oriDataList[0].p4"
          placeholder="请输入"
          clearable
        ></el-input>
        <div v-else class="m-input" @click="updateFocusCell(`ori${$index}0p4`)">{{ row.oriDataList[0].p4 }}</div>
      </template>
    </el-table-column>
    <el-table-column align="center" min-width="100" :show-overflow-tooltip="false">
      <template v-slot:header>
        <div class="flx-center">
          <span>测点5</span>
          <el-button
            type="text"
            size="medium"
            icon="el-icon-edit-outline"
            @click="handleBatchEdit('测点5', 'oriDataList', 0, 'p5')"
          ></el-button>
        </div>
      </template>
      <template v-slot="{ row, $index }">
        <el-input
          v-if="focusCell === `ori${$index}0p5`"
          :id="`ori${$index}0p5`"
          v-model="row.oriDataList[0].p5"
          placeholder="请输入"
          clearable
        ></el-input>
        <div v-else class="m-input" @click="updateFocusCell(`ori${$index}0p5`)">{{ row.oriDataList[0].p5 }}</div>
      </template>
    </el-table-column>
    <el-table-column align="center" min-width="100" :show-overflow-tooltip="false">
      <template v-slot:header>
        <div class="flx-center">
          <span>测点6</span>
          <el-button
            type="text"
            size="medium"
            icon="el-icon-edit-outline"
            @click="handleBatchEdit('测点6', 'oriDataList', 0, 'p6')"
          ></el-button>
        </div>
      </template>
      <template v-slot="{ row, $index }">
        <el-input
          v-if="focusCell === `ori${$index}0p6`"
          :id="`ori${$index}0p6`"
          v-model="row.oriDataList[0].p6"
          placeholder="请输入"
          clearable
        ></el-input>
        <div v-else class="m-input" @click="updateFocusCell(`ori${$index}0p6`)">{{ row.oriDataList[0].p6 }}</div>
      </template>
    </el-table-column>
    <el-table-column label="测点7" min-width="100" align="center" :show-overflow-tooltip="false">
      <template v-slot:header>
        <div class="flx-center">
          <span>测点7</span>
          <el-button
            type="text"
            size="medium"
            icon="el-icon-edit-outline"
            @click="handleBatchEdit('测点7', 'oriDataList', 0, 'p7')"
          ></el-button>
        </div>
      </template>
      <template v-slot="{ row, $index }">
        <el-input
          v-if="focusCell === `ori${$index}0p7`"
          :id="`ori${$index}0p7`"
          v-model="row.oriDataList[0].p7"
          placeholder="请输入"
          clearable
        ></el-input>
        <div v-else class="m-input" @click="updateFocusCell(`ori${$index}0p7`)">{{ row.oriDataList[0].p7 }}</div>
      </template>
    </el-table-column>
    <el-table-column label="测点8" min-width="100" align="center" :show-overflow-tooltip="false">
      <template v-slot:header>
        <div class="flx-center">
          <span>测点8</span>
          <el-button
            type="text"
            size="medium"
            icon="el-icon-edit-outline"
            @click="handleBatchEdit('测点8', 'oriDataList', 0, 'p8')"
          ></el-button>
        </div>
      </template>
      <template v-slot="{ row, $index }">
        <el-input
          v-if="focusCell === `ori${$index}0p8`"
          :id="`ori${$index}0p8`"
          v-model="row.oriDataList[0].p8"
          placeholder="请输入"
          clearable
        ></el-input>
        <div v-else class="m-input" @click="updateFocusCell(`ori${$index}0p8`)">{{ row.oriDataList[0].p8 }}</div>
      </template>
    </el-table-column>
    <el-table-column label="测点9" min-width="100" align="center" :show-overflow-tooltip="false">
      <template v-slot:header>
        <div class="flx-center">
          <span>测点9</span>
          <el-button
            type="text"
            size="medium"
            icon="el-icon-edit-outline"
            @click="handleBatchEdit('测点9', 'oriDataList', 0, 'p9')"
          ></el-button>
        </div>
      </template>
      <template v-slot="{ row, $index }">
        <el-input
          v-if="focusCell === `ori${$index}0p9`"
          :id="`ori${$index}0p9`"
          v-model="row.oriDataList[0].p9"
          placeholder="请输入"
          clearable
        ></el-input>
        <div v-else class="m-input" @click="updateFocusCell(`ori${$index}0p9`)">{{ row.oriDataList[0].p9 }}</div>
      </template>
    </el-table-column>
    <el-table-column label="测点10" min-width="100" align="center" :show-overflow-tooltip="false">
      <template v-slot:header>
        <div class="flx-center">
          <span>测点10</span>
          <el-button
            type="text"
            size="medium"
            icon="el-icon-edit-outline"
            @click="handleBatchEdit('测点10', 'oriDataList', 0, 'p10')"
          ></el-button>
        </div>
      </template>
      <template v-slot="{ row, $index }">
        <el-input
          v-if="focusCell === `ori${$index}0p10`"
          :id="`ori${$index}0p10`"
          v-model="row.oriDataList[0].p10"
          placeholder="请输入"
          clearable
        ></el-input>

        <div v-else class="m-input" @click="updateFocusCell(`ori${$index}0p10`)">{{ row.oriDataList[0].p10 }}</div>
      </template>
    </el-table-column>
    <el-table-column label="测点11" min-width="100" align="center" :show-overflow-tooltip="false">
      <template v-slot:header>
        <div class="flx-center">
          <span>测点11</span>
          <el-button
            type="text"
            size="medium"
            icon="el-icon-edit-outline"
            @click="handleBatchEdit('测点11', 'oriDataList', 0, 'p11')"
          ></el-button>
        </div>
      </template>
      <template v-slot="{ row, $index }">
        <el-input
          v-if="focusCell === `ori${$index}0p11`"
          :id="`ori${$index}0p11`"
          v-model="row.oriDataList[0].p11"
          placeholder="请输入"
          clearable
        ></el-input>
        <div v-else class="m-input" @click="updateFocusCell(`ori${$index}0p11`)">{{ row.oriDataList[0].p11 }}</div>
      </template>
    </el-table-column>
    <el-table-column label="测点12" min-width="100" align="center" :show-overflow-tooltip="false">
      <template v-slot:header>
        <div class="flx-center">
          <span>测点12</span>
          <el-button
            type="text"
            size="medium"
            icon="el-icon-edit-outline"
            @click="handleBatchEdit('测点12', 'oriDataList', 0, 'p12')"
          ></el-button>
        </div>
      </template>
      <template v-slot="{ row, $index }">
        <el-input
          v-if="focusCell === `ori${$index}0p12`"
          :id="`ori${$index}0p12`"
          v-model="row.oriDataList[0].p12"
          placeholder="请输入"
          clearable
        ></el-input>
        <div v-else class="m-input" @click="updateFocusCell(`ori${$index}0p12`)">{{ row.oriDataList[0].p12 }}</div>
      </template>
    </el-table-column>
    <el-table-column min-width="100" align="center" :show-overflow-tooltip="false">
      <template v-slot:header>
        <div class="flx-center">
          <span>平均值</span>
          <el-button
            type="text"
            size="medium"
            icon="el-icon-edit-outline"
            @click="handleBatchEdit('平均值', 'oriDataList', 0, 'p13')"
          ></el-button>
        </div>
      </template>
      <template v-slot="{ row, $index }">
        <el-input
          v-if="focusCell === `ori${$index}0p13`"
          :id="`ori${$index}0p13`"
          v-model="row.oriDataList[0].p13"
          placeholder="请输入"
          clearable
        ></el-input>
        <div v-else class="m-input" @click="updateFocusCell(`ori${$index}0p13`)">{{ row.oriDataList[0].p13 }}</div>
      </template>
    </el-table-column>
    <el-table-column label="符合要求" min-width="180" align="center" :show-overflow-tooltip="false">
      <template v-slot="{ row }">
        <el-radio-group v-model="row.oriDataList[0].state">
          <el-radio :label="1">合格</el-radio>
          <el-radio :label="-1">不合格</el-radio>
        </el-radio-group>
      </template>
    </el-table-column>
    <el-table-column label="设备编号" align="center" min-width="180" :show-overflow-tooltip="false">
      <template v-slot="{ row }">
        <el-input v-model.trim="row.deviceNo" placeholder="请输入" clearable></el-input>
      </template>
    </el-table-column>

    <el-table-column align="center" width="80" fixed="right" :show-overflow-tooltip="false">
      <template slot="header">
        <el-button type="primary" size="mini" icon="el-icon-plus" circle @click="handletSampleAdd"></el-button>
      </template>
      <template v-slot="{ row, $index }">
        <el-popconfirm v-if="!row.isOld" title="确定要删除此条记录吗？" @confirm="handletSampleDelete($index)">
          <el-button slot="reference" type="danger" size="mini" icon="el-icon-delete" circle></el-button>
        </el-popconfirm>
      </template>
    </el-table-column>

    <!-- 批量设置 检验日期、设备、温度、湿度等 弹窗 -->
    <WriteBatch ref="writeBatch" :visible.sync="batchSelectVisible" @batchSampleAdd="batchSampleAdd"></WriteBatch>
    <!-- 批量编辑样品属性 弹窗 -->
    <SelectionEdit
      :visible.sync="batchEditVisible"
      :editTitle="editTitle"
      :editPropetyArray="editPropetyArray"
      @emitBatchEdit="emitBatchEdit"
    ></SelectionEdit>
  </el-table>
</template>

<script>
import sampleTemplateMixin from './common/sampleTemplateMixin';

export default {
  mixins: [sampleTemplateMixin],
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {
    batchSampleAdd(addList, sampleOtherParams) {
      for (let i = 0; i < addList.length; i++) {
        const element = addList[i];
        if (this.writeSampleList.some(item => item.itemNo === element.itemNo)) continue;

        this.writeSampleList.unshift({
          itemNo: element.itemNo,
          oriDataList: [
            {
              p1: '',
              p2: '',
              p3: '',
              p4: '',
              p5: '',
              p6: '',
              p7: '',
              p8: '',
              p9: '',
              p10: '',
              p11: '',
              p12: '',
              p13: '',
              state: 1
            }
          ],
          state: 0,
          ...sampleOtherParams
        });
      }

      this.writeSampleList.sort((a, b) => new Date(b.testedTime) - new Date(a.testedTime));
      this.$refs.oriTable.clearSelection();
    }
  },
  created() {},
  mounted() {},
  activated() {}
};
</script>
<style lang="scss" scoped>
@import url('./common/sampleTemplate.scss');
</style>
